import { combineReducers } from 'redux';
// Import reducers
import files from './settings_files_reducer';

export default combineReducers({
	files
});
